import * as queryString from 'query-string';
import * as React from 'react';
import { HashRouter, Route, RouteComponentProps } from 'react-router-dom';
import * as _ from 'underscore';

import { AngularDirective } from '../../../common/react/components/AngularDirective';
import { IConnectionAuthenticationScope } from '../../../ts/controllers/AuthenticateConnectionCtrl';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { GetDataConnectionAuthInfoRequest } from '../../../ts/ServerApi/requests/GetDataConnectionAuthInfoRequest';
import { IDataConnectionAuthInfo } from '../../../ts/ServerApi/types/IDataConnectionAuthInfo';
import { ServerService } from '../../../ts/services/ServerService';
import { ServiceLocator } from '../../ServiceLocator';

const template = `<div ng-controller="AuthenticateConnectionCtrl" ng-include="'authenticateConnection.html'"></div>`;

export interface AuthenticateConnectionRouterProps extends ReactDirectiveProps {}

/**
 * This is the authenticate data connection UI used as a fallback when signing into a data connection on the viz page.
 * It is then shown through viz client in an iframe.
 * The path is just a plain /authenticate regardless of site
 */
export class AuthenticateConnectionRouter extends React.PureComponent<AuthenticateConnectionRouterProps> {
  public render() {
    return (
      <HashRouter>
        <Route path={'/authenticate'} render={this.provider}/>
      </HashRouter>
    );
  }

  private provider = (routeProps: RouteComponentProps) => {
    return <AuthenticateConnectionProvider
      angularContext={this.props.angularContext}
      routeLocationSearch={routeProps.location.search}
    />;
  }
}

interface AuthenticateConnectionProviderProps extends ReactDirectiveProps {
  readonly routeLocationSearch: string;
}

interface AuthenticateConnectionProviderState {
  readonly authInfo: IDataConnectionAuthInfo;
}

class AuthenticateConnectionProvider extends React.PureComponent<AuthenticateConnectionProviderProps, AuthenticateConnectionProviderState> {
  private server: ServerService;
  private unmounted: boolean = false;

  public constructor(props: AuthenticateConnectionProviderProps) {
    super(props);
    this.state = {authInfo: undefined};
    this.server = ServiceLocator.get<ServerService>('ServerService');
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  public componentDidMount = async () => {
    // We expect following query values  //?path&attributes&vizqlSessionId&isPreview&closePopupWhenDone&disableSessionPing',
    const currentQueryValues = queryString.parse(this.props.routeLocationSearch);
    const authInfo = await this.server.sendRequest(new GetDataConnectionAuthInfoRequest(currentQueryValues));
    if (!this.unmounted) {
      this.setState({authInfo});
    }
  }

  public render() {
    if (!_.isUndefined(this.state.authInfo)) {
      return <AngularDirective template={template} angularContext={this.props.angularContext} setupScope={this.setupScope} />;
    } else {
      return null;
    }
  }

  private setupScope = (scope: ng.IScope) => {
    const childScope = scope.$new() as IConnectionAuthenticationScope;
    childScope.authInfo = this.state.authInfo;
    childScope.queryParams = queryString.parse(this.props.routeLocationSearch);
    return childScope;
  }
}
